import React from 'react';
import BetStakeInput from '../BetStakeInput/BetStakeInput';
import styles from './StakeInputContainer.module.scss';

const StakeInputContainer = ({ show, type, stake, setStake, isLive }) => {
    const changeStakeValue = value => {
        setStake({
            type,
            stake: value,
        });
    };

    return show ? (
        <div className={styles.stakeInputWrap}>
            <BetStakeInput
                stake={stake}
                setStakeValue={changeStakeValue}
                inputWidth={'100%'}
                isLive={isLive}
            />
        </div>
    ) : null;
};

export default StakeInputContainer;
